import React, { useEffect } from 'react';

import { DatePicker, Divider, Form, Input, Modal } from 'antd';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import appI18n from '../../../../config/i18n';

interface BukMigrationModalProps {
  isBukMigrationModalOpen: boolean;
  handleBukMigrationModalOk: (date: string, type: string) => void;
  handleBukMigrationModalCancel: () => void;
  loading: boolean;
}

function BukMigrationModal({
  isBukMigrationModalOpen,
  handleBukMigrationModalOk,
  handleBukMigrationModalCancel,
  loading,
}: BukMigrationModalProps) {
  const [form] = Form.useForm();
  const { t } = useTranslation(undefined, { i18n: appI18n });
  const dateFormat: string = useSelector((state: any) => state.intl.dateFormat);

  useEffect(() => {
    if (isBukMigrationModalOpen) {
      form.resetFields();
      form.setFieldsValue({ date: undefined });
    }
  }, [isBukMigrationModalOpen]);

  const onFinish = (values: any) => {
    handleBukMigrationModalOk(
      values.date.format('YYYY-MM-DD'),
      'BUK_LICENCE_MIGRATION_TO_GEO_VICTORIA_PROCESS'
    );
  };

  return (
    <Modal
      title={t(
        'scenes.buk.buk_to_geo_victoria_migration.components.buk_migration_modal.title'
      )}
      open={isBukMigrationModalOpen}
      onOk={() => {
        form.submit();
      }}
      onCancel={handleBukMigrationModalCancel}
      okText={t(
        'scenes.buk.buk_to_geo_victoria_migration.components.buk_migration_modal.ok_text'
      )}
      maskClosable={false}
      confirmLoading={loading}
      destroyOnClose
    >
      <Divider style={{ marginTop: '15px', marginBottom: '15px' }} />

      <Form form={form} layout="vertical" onFinish={onFinish} preserve={false}>
        <Form.Item
          name="date"
          label={t(
            'scenes.buk.buk_to_geo_victoria_migration.components.buk_migration_modal.labels.date'
          )}
          rules={[
            {
              required: true,
              message: t(
                'scenes.buk.buk_to_geo_victoria_migration.components.buk_migration_modal.validations.required'
              ),
            },
          ]}
        >
          <DatePicker
            allowClear={false}
            style={{ width: '100%' }}
            format={dateFormat}
          />
        </Form.Item>
        <Form.Item
          name="type"
          label={t(
            'scenes.buk.buk_to_geo_victoria_migration.components.buk_migration_modal.labels.type'
          )}
        >
          <Input
            type="text"
            defaultValue={t(
              'scenes.buk.buk_to_geo_victoria_migration.components.buk_migration_modal.labels.type_value'
            )}
            style={{ width: '100%', fontWeight: 'bold' }}
            readOnly
          />
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default BukMigrationModal;
